import * as React from 'react';
import classNames from 'classnames';
import './button.module.scss';

type Props = {
  id?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  type: 'primary' | 'secondary' | 'inverted';
  layout?: 'inline' | 'block';
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: () => any;
  href?: string;
  className?: string;
  styleName?: string;
  testid?: string;
};

export const Button = ({ id, children, type, className, layout = 'block', onClick, href, disabled, testid }: Props) => {
  const buttonClassNames = classNames('button', type, layout, { disabled: disabled });

  if (href) {
    return (
      <a
        id={id}
        href={disabled ? undefined : href}
        styleName={buttonClassNames}
        className={className}
        onClick={disabled ? undefined : onClick}
        data-testid={testid}
      >
        {children}
      </a>
    );
  }

  return (
    <div
      id={id}
      styleName={buttonClassNames}
      className={className}
      onClick={disabled ? undefined : onClick}
      data-testid={testid}
    >
      {children}
    </div>
  );
};
